import { useState } from "react";
import "../styles/comparison-logs.css";

export default function ComparisonLogs({ logs, currentStep }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="comparison-logs">
      <div className="tsplogs-header" >
        <h3>Algorithm Steps</h3>
        {/* <button className="toggle-logs-btn">
          {expanded ? "Hide Steps" : "Show Steps"}
        </button> */}
      </div>

      
        <div className="tsplogs-content">
          {logs.map((log, index) => (
            <div
              key={index}
              className={`tsplog-entry ${index === currentStep ? "active" : ""}`}
            >
              <div className="tsplog-step">Step {index + 1}</div>
              <div className="tsplog-title">{log.title}</div>
              <div className="tsplog-description">{log.description}</div>
              <div className="tsplog-details">{log.details}</div>
            </div>
          ))}
        </div>
      
    </div>
  );
}
